<template>
	<div>
		<loader v-if="is_load" />
		<template v-else>
		  <div v-if="ticket_detail.status == 'COMPLETE'" class="chat-container w-100 position-relative bg-green hide-scroll overflow-scroll" style="height: 100vh">
		    <div class="container pt-5 text-center">
		      <div class="border rounded-50 size-icon mx-auto">
		        <div class="bg-white rounded-50 size-icon-in">
		          <img src="../../assets/img/icon/correct.png" width="40" style="margin: 16px 15px">
		        </div>
		      </div>
		      <p class="mt-4 mb-0 heading-5-2 text-white">{{formatCurrency(ticket_detail.total_payment)}}</p>
		      <p class="mt-2 mb-4 body-2-2" style="color: #FFFFFFA6">{{formatDate(ticket_detail.transaction_date)}}</p>
		      <p class="body-2-4 text-white pt-4 mb-0">{{$t('merchant.ticket-code')}} {{ticket_detail.ticket_code}}</p>
		      <p class="sub-heading-1-2 text-white mt-2">{{$t('merchant.thanks-for-buying-tickets')}}</p>

		      <div class="mx-2 text-left bg-white pt-4 pb-0" style="border-radius: 8px;box-shadow: 0px 9px 11px 0px #00000052">
		        <div class="row slim-grid-row pb-4">
		          <div class="col-2 text-right">
		            <img src="../../assets/img/icon/tickets.png" class="pt-2" width="20">
		          </div>
		          <div class="col-9">
		            <p class="mb-1 body-2-1">{{ticket_detail.merchant.name}} Tickets</p>
		            <p class="mb-0 body-3-3-1 text-light-bold">{{$t('merchant.visit-date')}} : {{formatDate(ticket_detail.visit_date)}}</p>
		          </div>
		        </div>
		      </div>
		      <router-link :to="'/'+getMerchant().code+'/ticket/order-history/'+ticket_detail.tx_order_id">
		      <button class="btn mx-auto border rounded-6 py-2 text-white sub-heading-1-2" style="width: 245px;margin-top: 35px;">{{$t('general.ticket-detail')}}</button>
		      </router-link>
		    </div>
		    <div class="pt-12"></div>
		  </div>
		  <div v-else class="chat-container w-100 position-relative bg-light-page pb-5 hide-scroll overflow-scroll">
		    <div class="container mt-5 pt-5 text-center">
		      <div class="border rounded-50 border-color-red size-icon mx-auto">
		        <div class="bg-red rounded-50 size-icon-in">
		          <img src="../../assets/img/icon/close-white.png" width="40" style="margin: 16px 15px">
		        </div>
		      </div>
		      <p class="mt-2 mb-0 heading-5-2 color-red">FAILED</p>

		      <p class="sub-heading-1-2 mb-0 mt-4">Sorry...</p>
		      <p class="body-2-4 mb-0">Your transaction cannot be performed, please try again or contact our customer support.</p>
			  </div>
		  </div>
		</template>
	</div>
</template>
<script>
	import {get} from '@/services/index.js'
	import {formatCurrency,formatDate} from '@/utils/index.js'
	import {mapGetters} from 'vuex'
	export default{
		metaInfo(){
      return {
        title: 'Payment Result',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
		data() {
			return{
				is_load: true,
				ticket_detail: {}
			}
		},
		mounted(){
			this.getTicketDetail();
		},
		methods:{
			...mapGetters(['getMerchant','getMetaTitleTemplate']),
    	formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        return formatDate(date);
      },
			getTicketDetail(){
				this.is_load = true
        get("CORE","tx-ticket-detail/"+this.$route.params.tx_order_id).then(response=>{
          let res = response.data;
          if (res.success) {
            this.ticket_detail = res.data
          }
          this.is_load = false
        })
			}
		}
	}
</script>
<style scoped>
.size-icon {
    width: 85px;
    height: 85px;
    padding: 7px;
  }

  .size-icon-in {
    width: 70px;
    height: 70px
  }

  .hide-scroll::-webkit-scrollbar {
    display: none;
  }

  .hide-scroll {
    -ms-overflow-style: none;
  }

  .height-img{
  	height: 65px;
  }

  .note{
  	margin-top: 0px;
  }

  .discon{
  	margin-top: -8px;
  }

  .bg-red{
    background-color: #bb2124;
  }

  .color-red{
    color: #bb2124;
  }

  .border-color-red{
    border-color: #bb2124!important;
  }

  .border-color-info{
    border-color: #17a2b8!important;
  }

  .bg-info{
    background-color: #17a2b8;
  }
</style>


// WEBPACK FOOTER //
// src/pages/ticket/PaymentResult.vue